'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.decode = decode;
var Entities = require('html-entities').AllHtmlEntities;
var entities = new Entities();

/**
 * @param {object|array|string|number|boolean|null|undefined} Some value.
 * @return {mixed} The given argument, with its strings HTML-entity decoded.
 * @throws Error if given a function, or something with a function anywhere inside of it.
 */
function decode(val) {
  if (val === null) {
    return val;
  } else if (typeof val === 'undefined') {
    return val;
  } else if (typeof val === 'boolean') {
    return val;
  } else if (typeof val === 'number') {
    return val;
  } else if (typeof val === 'string') {
    return entities.decode(val);
  } else if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    if (Array.isArray(val)) {
      return val.map(function (_) {
        return decode(_);
      });
    } else {
      var _ret = function () {
        var decoded = {};
        Object.keys(val).forEach(function (_) {
          return decoded[_] = decode(val[_]);
        });
        return {
          v: decoded
        };
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  } else {
    throw new Error('Does not work with type `' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '`');
  }
}

var entityDecoder = exports.entityDecoder = {
  decode: decode
};


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/utils/entityDecoder.js
// module id = 474
// module chunks = 0